// ─── Game Settings ───
export const MAX_PLAYERS = 8;
export const TEAM_SIZE = 4;
export const TEAMS = 2;
export const ROUND_DURATION_SEC = 600; // 10 minutes
export const INTERMISSION_SEC = 10;
export const LOADOUT_PICK_SEC = 15;
export const RESPAWN_SEC = 8;
export const SPAWN_SHIELD_SEC = 3;
export const RECONNECT_GRACE_SEC = 10;

// ─── Physics ───
export const GRAVITY = 9.81;
export const SERVER_TICK_RATE = 20; // Hz
export const SERVER_TICK_MS = 1000 / SERVER_TICK_RATE;
export const CLIENT_SEND_RATE = 60; // Hz
export const INTERPOLATION_BUFFER_MS = 100;

// ─── Terrain ───
export const TERRAIN_WIDTH = 400; // game units
export const TERRAIN_DEPTH = 200;
export const TERRAIN_SEGMENTS_X = 512;
export const TERRAIN_SEGMENTS_Z = 256;
export const TERRAIN_MAX_HEIGHT = 80;
export const TERRAIN_EDGE_FALLOFF = 0.15; // fraction of map for border smoothing

// ─── Slope Traversal ───
export const TANK_MAX_SLOPE_DEG = 55; // degrees — tanks stop above this
export const INFANTRY_MAX_SLOPE_DEG = 65; // degrees — infantry stop above this
export const SLOPE_SPEED_FALLOFF_START_DEG = 20; // speed starts dropping here
export const SLOPE_SLIDE_FORCE = 12; // downhill slide acceleration on steep terrain

// ─── Tanks ───
export const TANK_HP = 200;
export const TANK_MOVE_SPEED = 8; // units/sec
export const TANK_TURN_SPEED = 1.5; // rad/sec
export const TANK_TURRET_SPEED = 2.0; // rad/sec
export const TANK_BARREL_MIN_ANGLE = 0; // radians
export const TANK_BARREL_MAX_ANGLE = Math.PI / 2; // 90 degrees
export const TANK_ENTER_DISTANCE = 5; // units — how close to enter

// ─── Infantry ───
export const INFANTRY_HP = 100;
export const INFANTRY_MOVE_SPEED = 6; // units/sec
export const INFANTRY_SPRINT_SPEED = 10;
export const INFANTRY_JUMP_FORCE = 5;
export const INFANTRY_HEIGHT = 1.8;
export const INFANTRY_RADIUS = 0.4;
export const HEADSHOT_MULTIPLIER = 2.0;
export const BODYSHOT_MULTIPLIER = 1.0;
export const LIMBSHOT_MULTIPLIER = 0.75;

// ─── Infantry Weapon Damage to Tanks ───
export const INFANTRY_VS_TANK_MULTIPLIER = 0.25;

// ─── Bazooka ───
export const BAZOOKA_DAMAGE = 250;
export const BAZOOKA_COOLDOWN_MS = 8000;
export const BAZOOKA_SPEED = 60; // units/sec
export const BAZOOKA_INFANTRY_DAMAGE = 40;
export const BAZOOKA_BLAST_RADIUS = 5;

// ─── Scoring ───
export const KILL_BONUS_POINTS = 50;
export const RESPAWN_PENALTY_POINTS = 1;

// ─── Network Ports ───
export const DEFAULT_SERVER_PORT = 3001;
export const DEFAULT_CLIENT_PORT = 5173;
